/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n'

/**
 * Imports the InspectorControls component, which is used to wrap
 * the block's custom controls that will appear in in the Settings
 * Sidebar when the block is selected.
 *
 * Also imports the React hook that is used to mark the block wrapper
 * element. It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#inspectorcontrols
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { InspectorControls, useBlockProps } from '@wordpress/block-editor'

/**
 * Imports the necessary components that will be used to create
 * the user interface for the block's settings.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/components/panel/#panelbody
 * @see https://developer.wordpress.org/block-editor/reference-guides/components/text-control/
 * @see https://developer.wordpress.org/block-editor/reference-guides/components/toggle-control/
 */
import {
	__experimentalHeading as Heading,
	ColorPicker,
	PanelBody,
	SelectControl,
	TextControl,
} from '@wordpress/components'
/**
 * Imports the useEffect React Hook. This is used to set an attribute when the
 * block is loaded in the Editor.
 *
 * @see https://react.dev/reference/react/useEffect
 */
import { useEffect } from 'react'

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @param {Object}   props               Properties passed to the function.
 * @param {Object}   props.attributes    Available block attributes.
 * @param {Function} props.setAttributes Function that updates individual attributes.
 *
 * @return {Element} Element to render.
 */
export default function Edit( { attributes, setAttributes } ) {
	const { headingText, headingStyle, headingTag, accentColor, borderColor } = attributes

	useEffect( () => {
		if ( !headingText ) {
			setAttributes( { headingText: 'This is a heading title' } )
		}
	}, [headingText, setAttributes] )

	let vp = headingTag

	if ( !vp || vp == 'undefined' || vp === undefined ) {
		vp = 1
	}

	const HeadingTagL = `h${vp}`

	const cStyle = {
		'--pcborder-cl': borderColor,
		'--pcaccent-cl': accentColor,
	}
	return (
		<>
			<InspectorControls>
				<PanelBody title={__( 'Settings', 'soledad' )}>
					<SelectControl
						label="Heading Tag"
						value={headingTag}
						options={[
							{ label: 'H1', value: '1' },
							{ label: 'H2', value: '2' },
							{ label: 'H3', value: '3' },
							{ label: 'H4', value: '4' },
							{ label: 'H5', value: '5' },
							{ label: 'H6', value: '6' },
						]}
						onChange={( headingNewTag ) => setAttributes( { headingTag: headingNewTag } )}
						__nextHasNoMarginBottom
					/>
					<SelectControl
						label="Style"
						value={headingStyle}
						options={[
							{ label: 'Style 1', value: 'style-1' },
							{ label: 'Style 2', value: 'style-2' },
							{ label: 'Style 3', value: 'style-3' },
							{ label: 'Style 4', value: 'style-4' },
							{ label: 'Style 5', value: 'style-5' },
							{ label: 'Style 6', value: 'style-6' },
						]}
						onChange={( headingNewStyle ) => setAttributes( { headingStyle: headingNewStyle } )}
						__nextHasNoMarginBottom
					/>
					<TextControl
						label={__(
							'Heading Title Text',
							'soledad',
						)}
						value={headingText}
						onChange={( value ) =>
							setAttributes( { headingText: value } )
						}
					/>
				</PanelBody>
			</InspectorControls>
			<InspectorControls group="styles">
				<PanelBody title={__( 'Heading Title Colors', 'soledad' )}>
					<Heading>Accent Color</Heading>
					<ColorPicker
						color={accentColor}
						onChange={( accentColorNew ) =>
							setAttributes( { accentColor: accentColorNew } )
						}
						enableAlpha
						defaultValue=""
					/>
					<Heading>Border Color</Heading>
					<ColorPicker
						color={borderColor}
						onChange={( borderColorNew ) =>
							setAttributes( { borderColor: borderColorNew } )
						}
						enableAlpha
						defaultValue=""
					/>
				</PanelBody>
			</InspectorControls>
			<div className={`pchead-e-block pchead-e-${headingStyle} heading${vp}-${headingStyle}`}>
				<HeadingTagL {...useBlockProps( { style: cStyle } )}>{headingText}</HeadingTagL></div>
		</>
	)
}
